export type QueryIntent = "nav" | "question" | "list"

const QUESTION_PREFIXES = new Set([
  "is",
  "are",
  "do",
  "does",
  "what",
  "which",
  "how",
  "can",
  "could",
  "will",
  "should",
])
const TOKEN_RE = /[\p{L}\p{N}]+/gu

/** Deterministic intent for the AI lane. `knownTokens` = lowercased biomarker/
 *  disease title tokens from the loaded search index (no LLM, no fetch). */
export function classifyIntent(
  query: string,
  knownTokens: ReadonlySet<string>
): QueryIntent {
  const q = query.trim().toLowerCase()
  if (!q) return "nav"
  const tokens = q.match(TOKEN_RE) ?? []
  const knownHits = tokens.filter((t) => knownTokens.has(t)).length
  if (q.includes(",") || knownHits >= 2) return "list"
  if (
    q.endsWith("?") ||
    (tokens[0] && QUESTION_PREFIXES.has(tokens[0])) ||
    tokens.length >= 5
  ) {
    return "question"
  }
  return "nav"
}
